module.exports = __webpack_public_path__ + "img/1.975f7ffc.jpg";